export type Language = "en" | "ko";

export const translations = {
  en: {
    menuSubtitle: "Five lanes. One castle. A commander that remembers.",
    enterBattle: "Enter Battle",
    betaSwitches: "Beta switches",
    accessibility: "Accessibility",
    highContrast: "Contrast",
    uiScale: "UI",
    zoomMap: "Zoom Map",
    unitAnim: "Unit Anim",
    clashCombat: "Clash Combat",
    on: "ON",
    off: "OFF",
    language: "한국어",
    lanePressure: "Lane Pressure",
    towers: "Towers",
    units: "Units",
    warChestReady: "War chest ready",
    counter: "Counter",
    counterReady: "Counter Ready",
    ultimate: "Horn",
    ultimateReady: "Horn Ready",
    ultimateNotReady: "Commander horn is not ready",
    playerUltimateUsed: "Rallying horn sounded",
    aiUltimateUsed: "The enemy commander declares dread on a lane",
    incomeUpgradeShort: "Income+",
    counterUpgradeShort: "Charge+",
    repairCastleShort: "Repair",
    economyBuildShort: "Vault",
    techShort: "Tech",
    techPanelTitle: "Tier I Tech",
    researched: "Done",
    techResearched: "Technology researched",
    techAlreadyResearched: "Already researched",
    techLimitReached: "Tech limit reached",
    economyBuildReady: "Vault mode: click a lane",
    economyBuilt: "Vault built",
    economyAlreadyBuilt: "That lane already has a vault",
    maxed: "MAX",
    needMoreGold: "Need more gold",
    noPadInRange: "No pad in range",
    padOccupied: "Pad occupied",
    towerBuilt: "Tower built",
    unitDeployed: "Unit deployed",
    unitQueued: "Unit queued",
    summonQueueFull: "Summon queue is full",
    summonQueueLabel: "Queue",
    upkeep: "Upkeep",
    incomeRate: "Income",
    economyOutpostCaptured: "Outpost captured",
    incomeUpgraded: "Gold income improved",
    counterChargeUpgraded: "Counter gauge charges faster",
    castleRepaired: "Castle repaired",
    castleRepairFull: "Castle is already fully repaired",
    castleRepairCoolingDown: "Repair crew is regrouping",
    incomeUpgradeMaxed: "Gold income is fully upgraded",
    counterChargeMaxed: "Counter charge is fully upgraded",
    aiMercyGranted: "The commander eases pressure, insultingly.",
    counterGaugeNotReady: "Counter gauge is not ready",
    counterattackLaunched: "Counterattack launched",
    towerUpgraded: "Tower upgraded",
    towerPriorityReady: "Tower target priority",
    towerPriorityChanged: "Tower target priority changed",
    towerPriorityNearest: "Near",
    towerPriorityLowestHp: "Weak",
    towerPriorityHighestThreat: "Threat",
    towerPrioritySiegeFirst: "Siege",
    towerPriorityFastFirst: "Fast",
    unitUpgraded: "Unit upgraded",
    unitAbility: "Skill",
    unitAbilityReady: "Skill ready",
    unitAbilityUsed: "Skill used",
    unitAbilityCooldown: "Skill cooling down",
    unitAbilityNoTarget: "No valid skill target",
    unitAbilityNone: "No selected unit skill",
    abilityShieldWall: "Shield Wall",
    abilityFireBurst: "Fire Burst",
    abilityRepairBurst: "Repair Burst",
    abilityRallyBanner: "Rally",
    veteranPromoted: "Veteran promoted",
    upgradeModeReady: "Upgrade mode: click a unit or tower",
    unitCommandReady: "Drag units, then right-click to command",
    unitCommandReadyTouch: "Tap units, then tap ground to command. Two-finger drag pans.",
    unitsSelected: "units selected",
    moveCommandIssued: "Move order issued",
    noUnitsSelected: "No units selected",
    noCrossingAvailable: "No open crossing to that lane",
    commandBlocked: "Order blocked",
    commandMarker: "Order",
    commandMove: "Move",
    commandRetreat: "Retreat",
    commandAdvance: "Advance",
    commandHold: "Hold",
    commandHoldSet: "Holding position.",
    commandAdvanceSet: "Advancing forward.",
    aiManeuverObserved: "I am shifting the line. Watch your empty roads.",
    aiRetreatObserved: "I am pulling that line back before you can trap it.",
    aiReinforceObserved: "I am reinforcing the lane you thought would break.",
    aiTowerTargeted: "AI marked a tower",
    aiTowerTargetMarker: "AI target",
    towerDestroyed: "Tower destroyed",
    objectiveComplete: "Objective complete",
    goldReward: "Gold",
    pointReward: "Points",
    buffReward: "Buff",
    topSegment: "Top",
    mainSegment: "Keep",
    bottomSegment: "Bottom",
    ready: "ready",
    aiFortress: "AI Fortress",
    blueCastle: "Blue Castle",
    aiCommander: "AI Commander",
    rivalCommander: "Rival commander",
    mocking: "mocking",
    defaultTaunt: "Raise your pretty blue flags.",
    chatPrompt: "Click to chat with commander",
    chatPlaceholder: "Type and press Enter...",
    you: "You",
    commanderOffline: "The commander channel is quiet. The fortress still advances.",
    commanderMisconfigured: "Commander backend URL is missing for this deployment.",
    commanderHealthFailed: "Commander health check failed. Check Pages Functions or VITE_COMMANDER_WS_URL.",
    commanderConnecting: "Linking",
    commanderConnected: "Linked",
    commanderHealthy: "Healthy",
    commanderRecovering: "Recovering",
    commanderError: "Error",
    cameraHint: "Wheel zoom | Right-drag pan | Click here to reset",
    cameraHintTouch: "Pinch controls unavailable | Two-finger drag pans | Tap to reset",
    fullscreen: "Full",
    speed: "Speed",
    fullscreenReady: "Fullscreen ready",
    fullscreenUnsupported: "Use Add to Home Screen for true fullscreen on this device.",
    victory: "Victory",
    castleBroken: "Castle Broken",
    commanderSilent: "The commander is silent, for now.",
    goodMoves: "Worked well",
    fixNext: "Fix next",
    nextThreat: "Next threat",
    adaptiveLanePressure: "Adaptive lane pressure.",
    clickReturn: "Click to return to the war room",
    commanderLevel: "Lv",
    warFunds: "War Funds",
    xpGained: "XP",
    levelUp: "LEVEL UP!",
    rewardsTitle: "Spoils",
    audio: "Audio",
    audioOn: "On",
    audioOff: "Muted",
    modeNormal: "Normal",
    modeHard: "Hard",
    modeEndless: "Endless",
    modeLabel: "Mode",
    bestEndless: "Best survival",
    dailyChallenge: "Daily Challenge",
    dailyToday: "Today",
    dailyBestScore: "Best",
    dailyStreak: "Streak",
    dailyCompleted: "Cleared",
    dailyRunScore: "Score",
    dailyNewBest: "New best!",
    share: "Share",
    linkCopied: "Link copied!",
    shared: "Shared!",
    nemesisRematch: "⚔️ Rematch",
    leaderboard: "Leaderboard",
    leaderboardShort: "🏆 Ranks",
    leaderboardDaily: "Daily Challenge",
    leaderboardEndless: "Endless Survival",
    leaderboardLoading: "Loading…",
    leaderboardEmpty: "No scores yet — be the first!",
    support: "♥ Support",
    dmod_iron_tide: "Iron Tide",
    dmod_blitz: "Blitz",
    dmod_warlord: "Warlord",
    dmod_famine: "Famine",
    dmod_scorched: "Scorched Earth",
    dmod_warchest: "War Chest",
    dmod_skirmish: "Skirmish",
    banners: "Banners",
    bannerEquipped: "Equipped",
    bannerEquip: "Equip",
    shop: "Armory",
    shopTitle: "War Funds Armory",
    buy: "Buy",
    level: "Lv",
    notEnoughFunds: "Not enough War Funds",
    upg_war_chest: "War Chest",
    upg_war_chest_desc: "+60 starting gold per level",
    upg_fortify: "Fortify",
    upg_fortify_desc: "+8% castle HP per level",
    upg_foresight: "Foresight",
    upg_foresight_desc: "Cheaper early tech per level",
    career: "Career",
    careerTitle: "War Record",
    achievements: "Achievements",
    winRate: "Win rate",
    battles: "Battles",
    avgSurvival: "Avg. survival",
    favoriteTowers: "Favorite towers",
    favoriteUnits: "Favorite units",
    strongLanes: "Strong lanes",
    weakLanes: "Weak lanes",
    veteranRoster: "Veteran roster",
    rivalryTimeline: "Rivalry timeline",
    achievementUnlocked: "Achievement unlocked",
    backToMenu: "Back to menu",
    noVeterans: "No veterans yet",
    locked: "Locked",
    ach_first_blood: "First Blood",
    ach_first_win: "First Victory",
    ach_comeback_king: "Comeback King",
    ach_rival_reached: "A Worthy Rival",
    ach_obsession: "Obsession",
    ach_respected: "Respected Enemy",
    ach_veteran_corps: "Veteran Corps",
    ach_strategist: "Master Strategist",
    ach_level_5: "Seasoned Commander",
    ach_level_10: "Legendary Commander",
    ach_persistent: "Relentless",
    ach_nemesis_slayer: "Nemesis Slayer",
    ach_daily_clear: "Daily Duelist",
    ach_streak_7: "Weeklong Rival",
    ach_endless_survivor: "Last Stand",
    ach_collector: "Banner Collector",
    ach_war_economy: "War Economy",
    ach_level_20: "Grand Commander",
    tutorial: "Tutorial",
    tutorialNext: "Next",
    tutorialSkip: "Skip",
    tutorialDone: "Start",
    tutorial1: "Build towers on stone pads. Wall bastions must be broken before enemies can pass.",
    tutorial2: "Select a unit, then click a lane. The unit stays selected so you can summon repeatedly.",
    tutorial3: "Click your units or towers with no build selection to upgrade them with random stat growth.",
    tutorial4: "Capture lane objectives for gold, points, or temporary buffs.",
    tutorial5: "Top lanes hit the top castle, middle hits the keep, and bottom lanes hit the bottom castle."
  },
  ko: {
    menuSubtitle: "다섯 개의 전선. 하나의 성. 기억하는 지휘관.",
    enterBattle: "전투 시작",
    betaSwitches: "베타 기능",
    accessibility: "접근성",
    highContrast: "고대비",
    uiScale: "UI",
    zoomMap: "지도 확대",
    unitAnim: "유닛 애니메이션",
    clashCombat: "충돌 전투",
    on: "켜짐",
    off: "꺼짐",
    language: "English",
    lanePressure: "전선 압박",
    towers: "타워",
    units: "유닛",
    warChestReady: "군자금 준비 완료",
    counter: "반격",
    counterReady: "반격 준비",
    ultimate: "나팔",
    ultimateReady: "나팔 준비",
    ultimateNotReady: "지휘관 나팔이 아직 준비되지 않았습니다",
    playerUltimateUsed: "집결 나팔을 울렸습니다",
    aiUltimateUsed: "적 지휘관이 전선에 공포를 선포했습니다",
    incomeUpgradeShort: "수입+",
    counterUpgradeShort: "반격+",
    repairCastleShort: "수리",
    economyBuildShort: "금고",
    techShort: "기술",
    techPanelTitle: "1티어 기술",
    researched: "완료",
    techResearched: "기술 연구 완료",
    techAlreadyResearched: "이미 연구된 기술입니다",
    techLimitReached: "기술 한도에 도달했습니다",
    economyBuildReady: "금고 모드: 전선을 클릭하세요",
    economyBuilt: "금고 건설 완료",
    economyAlreadyBuilt: "해당 전선에는 이미 금고가 있습니다",
    maxed: "최대",
    needMoreGold: "골드가 부족합니다",
    noPadInRange: "범위 안의 건설 지점이 없습니다",
    padOccupied: "이미 점유된 지점입니다",
    towerBuilt: "타워 건설 완료",
    unitDeployed: "유닛 배치 완료",
    unitQueued: "유닛 출격 예약",
    summonQueueFull: "소환 대기열이 가득 찼습니다",
    summonQueueLabel: "대기열",
    upkeep: "유지비",
    incomeRate: "수입",
    economyOutpostCaptured: "경제 거점 장악",
    incomeUpgraded: "골드 수입이 더 빨라졌습니다",
    counterChargeUpgraded: "반격 게이지 충전이 빨라졌습니다",
    castleRepaired: "성 수리 완료",
    castleRepairFull: "성은 이미 최대 내구도입니다",
    castleRepairCoolingDown: "수리 인력이 재정비 중입니다",
    incomeUpgradeMaxed: "골드 수입은 이미 최대입니다",
    counterChargeMaxed: "반격 충전은 이미 최대입니다",
    aiMercyGranted: "지휘관이 모욕적으로 압박을 늦췄습니다",
    counterGaugeNotReady: "반격 게이지가 아직 부족합니다",
    counterattackLaunched: "반격을 시작했습니다",
    towerUpgraded: "타워 강화 완료",
    towerPriorityReady: "타워 공격 우선순위",
    towerPriorityChanged: "타워 공격 우선순위 변경",
    towerPriorityNearest: "근접",
    towerPriorityLowestHp: "약체",
    towerPriorityHighestThreat: "위협",
    towerPrioritySiegeFirst: "공성",
    towerPriorityFastFirst: "고속",
    unitUpgraded: "유닛 강화 완료",
    unitAbility: "스킬",
    unitAbilityReady: "스킬 준비",
    unitAbilityUsed: "스킬 사용",
    unitAbilityCooldown: "스킬 재사용 대기",
    unitAbilityNoTarget: "스킬 대상이 없습니다",
    unitAbilityNone: "선택 유닛 스킬 없음",
    abilityShieldWall: "방패벽",
    abilityFireBurst: "화염 폭발",
    abilityRepairBurst: "긴급 수리",
    abilityRallyBanner: "집결 깃발",
    veteranPromoted: "베테랑 승격",
    upgradeModeReady: "강화 모드: 유닛이나 타워를 클릭하세요",
    unitCommandReady: "유닛을 드래그 선택 후 우클릭으로 명령하세요",
    unitCommandReadyTouch: "유닛을 탭한 뒤 땅을 탭해 명령하세요. 두 손가락 드래그로 이동합니다.",
    unitsSelected: "유닛 선택됨",
    moveCommandIssued: "이동 명령 전달",
    noUnitsSelected: "선택된 유닛이 없습니다",
    noCrossingAvailable: "해당 전선으로 열린 통로가 없습니다",
    commandBlocked: "명령 불가",
    commandMarker: "명령",
    commandMove: "이동",
    commandRetreat: "후퇴",
    commandAdvance: "돌격",
    commandHold: "정지",
    commandHoldSet: "그 자리를 지킵니다.",
    commandAdvanceSet: "계속 전진합니다.",
    aiManeuverObserved: "전선을 옮기겠다. 비어 있는 길을 잘 보아라.",
    aiRetreatObserved: "그 전선은 빠진다. 네 포위에 헌납하진 않겠다.",
    aiReinforceObserved: "네가 뚫는다고 믿은 전선에 병력을 다시 세우겠다.",
    aiTowerTargeted: "AI가 타워를 표적으로 지정했습니다",
    aiTowerTargetMarker: "AI 표적",
    towerDestroyed: "타워 파괴됨",
    objectiveComplete: "목표 완료",
    goldReward: "골드",
    pointReward: "포인트",
    buffReward: "버프",
    topSegment: "상단",
    mainSegment: "본성",
    bottomSegment: "하단",
    ready: "준비",
    aiFortress: "AI 요새",
    blueCastle: "푸른 성",
    aiCommander: "AI 지휘관",
    rivalCommander: "상대 지휘관",
    mocking: "도발 중",
    defaultTaunt: "푸른 깃발을 마음껏 올려 보아라.",
    chatPrompt: "클릭해서 지휘관과 대화",
    chatPlaceholder: "입력 후 Enter...",
    you: "나",
    commanderOffline: "지휘관 채널은 조용합니다. 그러나 요새는 계속 진군합니다.",
    commanderMisconfigured: "배포 환경의 지휘관 백엔드 URL이 설정되지 않았습니다.",
    commanderHealthFailed: "지휘관 상태 확인에 실패했습니다. Pages Functions 또는 VITE_COMMANDER_WS_URL을 확인하세요.",
    commanderConnecting: "연결 중",
    commanderConnected: "연결됨",
    commanderHealthy: "정상",
    commanderRecovering: "복구 중",
    commanderError: "오류",
    cameraHint: "휠 확대 | 우클릭 드래그 이동 | 클릭해서 시점 초기화",
    cameraHintTouch: "두 손가락 드래그 이동 | 탭해서 시점 초기화",
    fullscreen: "전체",
    speed: "속도",
    fullscreenReady: "전체화면으로 전환했습니다",
    fullscreenUnsupported: "이 기기는 홈 화면에 추가해야 진짜 전체화면으로 열립니다.",
    victory: "승리",
    castleBroken: "성 함락",
    commanderSilent: "지휘관은 아직 침묵하고 있습니다.",
    goodMoves: "잘한 점",
    fixNext: "다음 보완",
    nextThreat: "다음 위협",
    adaptiveLanePressure: "적응형 전선 압박.",
    clickReturn: "클릭해서 작전실로 돌아가기",
    commanderLevel: "Lv",
    warFunds: "군자금",
    xpGained: "XP",
    levelUp: "레벨 업!",
    rewardsTitle: "전리품",
    audio: "소리",
    audioOn: "켜짐",
    audioOff: "음소거",
    modeNormal: "일반",
    modeHard: "어려움",
    modeEndless: "무한",
    modeLabel: "모드",
    bestEndless: "최고 생존",
    dailyChallenge: "오늘의 도전",
    dailyToday: "오늘의 변수",
    dailyBestScore: "최고 점수",
    dailyStreak: "연속",
    dailyCompleted: "클리어",
    dailyRunScore: "점수",
    dailyNewBest: "신기록!",
    share: "공유",
    linkCopied: "링크 복사됨!",
    shared: "공유됨!",
    nemesisRematch: "⚔️ 네메시스",
    leaderboard: "리더보드",
    leaderboardShort: "🏆 순위",
    leaderboardDaily: "오늘의 도전",
    leaderboardEndless: "무한 생존",
    leaderboardLoading: "불러오는 중…",
    leaderboardEmpty: "아직 점수가 없습니다 — 1등이 되어보세요!",
    support: "♥ 후원",
    dmod_iron_tide: "강철 해일",
    dmod_blitz: "전격전",
    dmod_warlord: "대군주",
    dmod_famine: "기근",
    dmod_scorched: "초토화",
    dmod_warchest: "군자금 보급",
    dmod_skirmish: "소규모 접전",
    banners: "사령관 깃발",
    bannerEquipped: "장착됨",
    bannerEquip: "장착",
    shop: "병기고",
    shopTitle: "군자금 병기고",
    buy: "구매",
    level: "Lv",
    notEnoughFunds: "군자금이 부족합니다",
    upg_war_chest: "전시 자금",
    upg_war_chest_desc: "레벨당 시작 골드 +60",
    upg_fortify: "요새 보강",
    upg_fortify_desc: "레벨당 성 체력 +8%",
    upg_foresight: "선견지명",
    upg_foresight_desc: "레벨당 초반 기술 비용 인하",
    career: "전적",
    careerTitle: "전투 기록",
    achievements: "업적",
    winRate: "승률",
    battles: "전투 수",
    avgSurvival: "평균 생존",
    favoriteTowers: "선호 타워",
    favoriteUnits: "선호 유닛",
    strongLanes: "강한 전선",
    weakLanes: "약한 전선",
    veteranRoster: "베테랑 명단",
    rivalryTimeline: "라이벌 연대기",
    achievementUnlocked: "업적 달성",
    backToMenu: "메뉴로",
    noVeterans: "아직 베테랑이 없습니다",
    locked: "잠김",
    ach_first_blood: "첫 출전",
    ach_first_win: "첫 승리",
    ach_comeback_king: "역전의 명수",
    ach_rival_reached: "맞수의 자격",
    ach_obsession: "집착",
    ach_respected: "존중받는 적",
    ach_veteran_corps: "베테랑 군단",
    ach_strategist: "전략의 대가",
    ach_level_5: "노련한 지휘관",
    ach_level_10: "전설의 지휘관",
    ach_persistent: "불굴",
    ach_nemesis_slayer: "네메시스 학살자",
    ach_daily_clear: "오늘의 결투자",
    ach_streak_7: "일주일의 맞수",
    ach_endless_survivor: "최후의 보루",
    ach_collector: "깃발 수집가",
    ach_war_economy: "전쟁 경제",
    ach_level_20: "대지휘관",
    tutorial: "튜토리얼",
    tutorialNext: "다음",
    tutorialSkip: "건너뛰기",
    tutorialDone: "시작",
    tutorial1: "돌 패드에 타워를 건설하세요. 성벽 타워는 적이 부수기 전까지 반드시 길을 막습니다.",
    tutorial2: "유닛을 선택한 뒤 전선을 클릭하세요. 유닛 선택이 유지되어 연속 소환할 수 있습니다.",
    tutorial3: "건설 선택이 없을 때 아군 유닛이나 타워를 클릭하면 랜덤 스탯 강화가 됩니다.",
    tutorial4: "전선 목표를 점령하면 골드, 포인트, 임시 버프 중 하나를 얻습니다.",
    tutorial5: "위 2개 전선은 상단 성, 중앙은 본성, 아래 2개 전선은 하단 성을 공격합니다."
  }
} as const;

type TranslationKey = keyof typeof translations.en;

export function t(language: Language, key: TranslationKey) {
  return translations[language][key];
}

export function toggleLanguage(language: Language): Language {
  return language === "en" ? "ko" : "en";
}

export function threatLabel(language: Language, level: string) {
  if (language === "en") return level;
  switch (level) {
    case "collapse":
      return "붕괴";
    case "danger":
      return "위험";
    case "contested":
      return "교전";
    case "watch":
      return "주의";
    case "safe":
      return "안전";
    case "critical":
      return "위험";
    case "high":
      return "높음";
    case "medium":
      return "중간";
    case "low":
      return "낮음";
    case "none":
    default:
      return "없음";
  }
}

export function moodLabel(language: Language, mood: string) {
  if (language === "en") return mood;
  switch (mood) {
    case "furious":
      return "분노";
    case "insane":
      return "광기";
    case "tactical":
      return "전술";
    case "calm":
      return "침착";
    case "amused":
      return "흥미";
    case "mocking":
    default:
      return "도발";
  }
}

export function localizeCommanderLine(language: Language, text: string) {
  if (language === "en") return text;
  if (text.includes("Raise your pretty blue flags")) return "푸른 깃발을 마음껏 올려 보아라. 표적이 잘 보이는군.";
  if (text.includes("careful wall")) return "조심스러운 방벽이군. 어떤 돌이 비어 있는지 곧 알아내겠다.";
  if (text.includes("central road is polished")) return "중앙 대로만 반짝이는군. 양쪽 끝은 얼마나 약할까?";
  if (text.includes("counterattack forming")) return "반격을 준비하는군. 허비하게 만들어 주겠다.";
  if (text.includes("Lane") && text.includes("looks thin")) return "그 전선이 얇아 보이는군. 곧 찢어 보겠다.";
  if (text.includes("survived long enough")) return "제법 버텼군. 이제 전선을 갈라 주겠다.";
  if (text.includes("commander channel is quiet")) return "지휘관 채널은 조용합니다. 그러나 요새는 계속 진군합니다.";
  return text;
}
